<template>
  <section class="main-width mb-10">
    <section class="my-5">
      <VBreadcrumb :class="$style.breadcrumb" :options="breadcrumbs" />
    </section>
    <div class="shadow mb-8 p-6" :class="$style.searchWrap">
      <ProductFilterItem v-if="!searchData.cruise_route_first && !searchData.route" label="邮轮航线" :items="routes">
      </ProductFilterItem>
      <ProductFilterItem v-if="!searchData.month && !searchData.date_start && !searchData.date_end" label="出发日期"
        :items="travelDates">
        <template #append>
          <el-date-picker :class="$style.dateRange" :value="dateRange" type="daterange" range-separator="至"
            start-placeholder="最早出发日期" size="mini" end-placeholder="最晚出发日期" value-format="yyyy-MM-dd"
            :picker-options="datePickerOptions" @input="onDateChange" />
        </template>
      </ProductFilterItem>
      <ProductFilterItem v-if="!searchData.company && !searchData.cruise" label="邮轮品牌" :items="brands">
      </ProductFilterItem>
      <ProductFilterItem v-if="!searchData.country && !searchData.city" label="出发城市" :items="cities"></ProductFilterItem>
      <ProductFilterItem v-if="!searchData.day" label="出游天数" :items="days"></ProductFilterItem>
      <ProductFilterItem v-if="!searchData.tag && !searchData.cruise_type && tags.length" label="标签" :items="tags">
      </ProductFilterItem>
      <div class="flex items-center pt-6 border-t mt-3" v-show="labels && labels.length">
        <div class="text-base font-medium text-dark mr-6" style="width: 4.5em">
          您已选择
        </div>
        <div class="flex">
          <nuxt-link v-for="(label, index) in labels" :key="index" custom #default="{ href }" :to="{
            query: label.query,
          }">
            <a :class="$style.condition" class="group"
              :href="href" target="_self"><span>{{ label.label }}</span>
              <span class="ml-1 text-secondary group-hover:text-primary"><i class="el-icon-close" /></span></a>
          </nuxt-link>
        </div>
      </div>
    </div>
    <section :class="$style.layout">
      <section :class="$style.layout_main">
        <section :class="$style.content">
          <section :class="$style.search_result">
            <filter-sort-bar :initSort="[searchData.sort_name]" :initSortType="searchData.sort_type"  :count="productData.total_count" />
            <!--置顶推荐-->
            <section :class="$style.top_list_wrapper" v-if="productData.top_list && productData.top_list.length">
              <div :class="$style.top_flag">推荐</div>
              <ProductItem :loading="isProductLoading" :class="$style.product_item" v-for="product in productData.top_list" :key="product.product_no" :product="product" />
            </section>
            <section :class="$style.product_list" v-if="productData.list && productData.list.length">
              <ProductItem :loading="isProductLoading" :class="$style.product_item" v-for="product in productData.list"
                :key="product.product_no" :product="product" />
            </section>
          </section>

          <no-result v-if="productData.list && productData.list.length == 0" style="margin-bottom: 40px">
            <template #title>目前没有满足所有筛选项的产品，请尝试放大筛选范围</template>
          </no-result>
        </section>
        <section :class="$style.pager_wrap" v-if="productData.list && productData.list.length">
          <section :class="$style.pager_total">
            共{{ productData.total_count }}条
          </section>
          <v-pagination :class="$style.pager" :total="productData.total_count" :page="productData.page_index"
            :pageSize="productData.page_size" prevText="上一页" nextText="下一页" @current-change="onPageChange">
            <!-- <template #prev="{disabled, page}">
              <nuxt-link v-if="!disabled" class="ui-btn ui-btn-small ui-btn-disabled" :to="{
                path: $router.path,
                query: {
                  ...$route.query,
                  page_index: page
                }
              }" >
                <i class="el-icon-arrow-left mr-1"></i>
                上一页
              </nuxt-link>
              <span v-else class="ui-btn ui-btn-small ui-btn-disabled"><i class="el-icon-arrow-left mr-1"></i>上一页</span>
            </template> -->
            <template #item="{page, isActive, type}">
              <nuxt-link class="ui-btn ui-btn-small" :class="{
                '!border-darker': isActive
              }" :to="{
                path: $router.path,
                query: {
                  ...$route.query,
                  page_index: page
                }
              }" custom>
              <template v-if="type === 'number'" #default="{ href }">
                  <a v-if="!isActive" :href="href"  target="_self">{{ page }}</a>
                  <span v-else>{{ page }}</span>
                <!-- <component :is="" href="href" target="_self" rel="nofollow">
                {{ page }}
              </component> -->
            </template> 
              <template v-else #default="{ href }"><a :href="href" target="_self" rel="nofollow">
                <i :class=" type === 'jump-prev' ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right' "></i>
              </a></template>  
            </nuxt-link>
            </template>
            <!-- <template #next="{disabled, page}">
              {{disabled}}
              <nuxt-link v-if="!disabled" class="ui-btn ui-btn-small" target="_self" :to="{
                path: $router.path,
                query: {
                  ...$route.query,
                  page_index: page
                }
              }" >
                下一页
                <i class="el-icon-arrow-right ml-1"></i>

              </nuxt-link>


              <span v-else class="ui-btn ui-btn-small ui-btn-disabled">下一页<i class="el-icon-arrow-right ml-1"></i></span>
            </template> -->
          </v-pagination>
        </section>

        <!-- <ProductTripDialog /> -->
      </section>
      <section :class="$style.layout_aside">
        <PlatformAdvertStairSwiper :items="adStore.banner" />

        <PlatformAdvertStair v-for="(rec, index) in adStore.recommend" :key="index"
          :background_color="rec.background_color" :title="rec.name" :icon-url="rec.icon" :items="rec.products" :isShowFirstItemTopMargin="adStore.banner?.length" />
          
        <!-- <PlatformAdvertStair title="松赞优选" /> -->
      </section>
    </section>

    <AppDock />
  </section>
</template>

<script>
import {
  useRouter,
  defineComponent,
  // watch,
  reactive,
  // ref,
  useFetch,
  useMeta,
  useRoute,
  // useCssModule,
  computed
} from "@nuxtjs/composition-api";

import SortGroup from "@/components/Sort/SortGroup.vue";
import NoResult from "@/views/product/components/ListNoResult";
import Profit from "@/components/Profit.vue";

import usePlatformAdvertStairStore from "~/composables/usePlatformAdvertStairStore";

import { omit, get, dayjs } from "~/utils/helpers";


import ProductItem from "~/components/automation/product-list-item.vue";
import VPagination from "~/components/VPagination/index.vue";
import PlatformAdvertStair from "~/components/product/PlatformAdvertStair.vue";
import ProductFilterItem from "~/components/automation/product-filter-item.vue";

import PlatformAdvertStairSwiper from "~/components/product/PlatformAdvertStairSwiper.vue";

import FilterSortBar from "@/components/product/filterSortBar.vue";

import VBreadcrumb from "@/components/VBreadcrumb.vue";

import AppDock from "~/components/layouts/AppDock.vue";


import {
  useProductCruiseFilter,
  useProductCruiseList,
  useProductCruiseDate
} from "~/composables/automation";

export default defineComponent({
  name: "foreign-cruise-search",
  auth: false,
  layout: "Main",
  watchQuery: ['page'],
  components: {
    VBreadcrumb,

    ProductFilterItem,
    ProductItem,
    VPagination,
    SortGroup,
    Profit,

    NoResult,

    AppDock,

    PlatformAdvertStair,
    PlatformAdvertStairSwiper,
    FilterSortBar,
  },
  head: {},
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isHomePort = computed(() => route.value.query.home_port || '0');

    useMeta(() => ({
      title: "资源采购",
    }));

    const {
      state: filterData,
      routes,
      travelDates,
      brands,
      cities,
      days,
      tags,
      execute: fetchFilterData,
      searchData,
      labels,

      dateRange,
    } = useProductCruiseFilter(() => ({
      home_port: isHomePort.value
    }));


    const {
      state: dates,
      execute: fetchDates
    } = useProductCruiseDate();
    // const styles = useCssModule();
    // const

    // const dateRange = ref([]);

    // ======================= 列表 =======================
    const {
      state: productData,
      isLoading: isProductLoading,
      execute: fetchProducts,
      pageIndex,
      onPageChange,
    } = useProductCruiseList(() => {
      let {
        month,
        day = '',
        sort_name = '1',
        sort_type = '',
        ...param
      } = searchData;
      const [min_day = '', max_day = ''] = day ? day.split('-') : ['', '']
      return {
        ...param,
        travel_date: month,
        sort_name,
        sort_type,
        home_port: isHomePort.value,
        day: {
          min: min_day,
          max: max_day
        }
      };
    });
    useFetch(async () => {
      await Promise.all([fetchFilterData(), fetchProducts(), fetchDates()]);
    });

    // ======================= 分页 =======================
    const pagination = reactive({
      page_index: 1,
      page_size: 10,
      total_page: 1,
      total_count: 0,
    });

    // const onPageChange = (index) => {
    //   pageIndex.value = index;
    //   fetchProducts();
    //   scrollToTop();
    // };

    // ======================= 排序 =======================


    const onDateChange = (value) => {
      let [date_start = "", date_end = ""] = value || [];
      const resolved = router.resolve({
        query: {
          ...route.value.query,
          month: '',
          date_start,
          date_end,
        },
      });
      console.log(resolved);
      window.location.href = resolved.href;
    };
    // ======================= 推荐位 =======================
    const adStore = usePlatformAdvertStairStore("cruise_search_right");

    const breadcrumbs = [{ label: "首页", to: "/" }, { label: "邮轮产品列表" }];

    return {
      filterData,

      searchData,
      // onClearFilter,

      isProductLoading,
      productData,

      pagination,
      onPageChange,

      adStore,

      breadcrumbs,

      dates,

      routes,
      travelDates,
      brands,
      cities,
      days,
      tags,
      labels,

      omit,

      dateRange,
      onDateChange,

      pageIndex,
      onPageChange,
    };
  },
  data() {
    return {
      datePickerOptions: {
        cellClassName: (date) => {
          return this.dates.includes(dayjs(date).format('YYYY-MM-DD')) ? this.$style.highlight : ''
        }
      }
    }
  },
  mounted() {
    console.log(this.datePickerOptions)
  }
});
</script>

<style lang="scss" module>
.pager_total {
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.layout_main {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  width: 0px;
}
.layout_aside {
  margin-left: 1.25rem;
  width: 15.625rem;
}
.searchWrap {
  background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
}
.content {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.top_list_wrapper {
  position: relative;
  border: 2px solid #FE862D;
  padding-top: 36px;
  padding-bottom: 17px;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
}
.top_list_wrapper .top_flag {
  position: absolute;
  top: 0px;
  left: 0px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 57px;
  height: 34px;
  line-height: 34px;
  background-color: #FE862D;
  border-radius: 0 0 10px 0;
  font-size: 20px;
  font-weight: 500;
}
.top_list_wrapper .product_item:last-child {
  border-bottom: none;
}
.pager_wrap {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-top: 1.25rem;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.product_item {
  border-bottom-width: 1px;
}
.ad {
  border-radius: 0.25rem;
  display: block;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.ad_img {
  border-radius: 0.25rem;
}
.dateRange {
  border-color: #c9cbd6;
  width: auto !important;
}
.dateRange :global(.el-range-input) {
  width: 100px;
  font-size: var(--font-size);
}
.dateRange :global(.el-range-separator) {
  width: 2em;
  font-size: var(--font-size);
}
.condition {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(25, 25, 25, var(--tw-border-opacity));
  border-radius: 0.25rem;
  border-width: 1px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-right: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.condition:hover {
  border-color: $color-primary;
  background-color: #dfedff;
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.highlight {
  background: #FDF1E5;
}
</style>
